import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { Box } from '@mui/material';

const RouterLayer = ({children}) => {
  const location = useLocation();
  useEffect(() => {
    // This code will run every time the route changes
    // console.log('Route changed to:', location.pathname);
    // You can perform actions here, like sending analytics events
    // or updating other parts of your application state.
    // todo: add scroll top
    window.scrollTo({ top: 0, behavior: 'smooth' }) 
  }, [location]); // Depend on 'location' to re-run the effect on route changes

  return (
    <Box p={2}>
      {children}
    </Box>
  )
}

export default RouterLayer